import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Sparkles } from 'lucide-react';

interface AiSmartAutomationSectionProps {
  title?: string;
  features: string[];
}

export const AiSmartAutomationSection = ({ 
  title = "Smart Automation (No More Manual Babysitting)",
  features
}: AiSmartAutomationSectionProps) => {
  return (
    <section className="py-16 bg-gradient-to-r from-primary/5 to-secondary/10">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-8">
          <Badge className="mb-4">AI-Powered</Badge>
          <h2 className="text-3xl font-bold">{title}</h2>
        </div>
        <Card>
          <CardContent className="pt-6">
            <ul className="space-y-4">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Sparkles className="w-5 h-5 text-primary mt-1 flex-shrink-0" />
                  <p className="text-sm">{feature}</p>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
        <p className="text-center text-sm text-muted-foreground mt-6">
          We're built for short-term rental hosts with 1–50 active listings, 
          not giant property management companies.
        </p>
      </div>
    </section>
  );
};
